import {
    FETCH_DOMAIN_GROUPS_REQUEST,
    FETCH_DOMAIN_GROUPS_SUCCESS,
    FETCH_DOMAIN_GROUPS_FAILURE,
    DELETE_DOMAIN_GROUP_REQUEST,
    DELETE_DOMAIN_GROUP_SUCCESS,
    DELETE_DOMAIN_GROUP_ERROR,
    SAVE_DOMAIN_GROUP_REQUEST,
    SAVE_DOMAIN_GROUP_SUCCESS,
    SAVE_DOMAIN_GROUP_FAILURE,
    DELETE_GROUPS_FROM_DOMAINS_REQUEST,
    DELETE_GROUPS_FROM_DOMAINS_SUCCESS,
    DELETE_GROUPS_FROM_DOMAINS_FAILURE,
    CREATE_DOMAIN_GROUP,
    SELECT_DOMAIN_GROUP,
    RENAME_SELECTED_DOMAIN_GROUP,
    UPDATE_DOMAINS_IN_SELECTED_GROUP,
    DISMISS_DOMAIN_GROUPING_FORM,
} from './types/domain-groups-action-types';
import { domainGroupsByIdSelector, domainGroupFormStateSelector } from '../../common/selectors/domain-groups-selectors';
import {
    isAssigningDomainsToGroupSelector,
    modalPreselectedDomainsForAGroupSelector
} from '../../system/domain-grouping/domain-grouping-selectors';
import {
    openRemoveDomainsFromGroupsErrorSnackbar,
    openRemoveDomainsFromGroupsSuccessSnackbar,
} from './snackbar-action-creators';
import {
    refreshClaimedDomains,
} from '../../system/actions/claimed-domains-action-creators';
import {
    openDomainGroupingDeleteSuccessSnackbar,
    openDomainGroupingEditSuccessSnackbar,
    openDomainGroupingSaveErrorSnackbar,
    openDomainGroupingCreateSuccessSnackbar,
    openDomainGroupingDeleteErrorSnackbar
} from '../../common/actions/snackbar-action-creators';
import MimirService from '../../common/services/mimir-service';
import { some, uniq } from 'lodash';
import domainGroupSanitizer from '../../common/services/middleware/domain-group-sanitizer';

function fetchDomainGroupsRequest(){
    return {
        type: FETCH_DOMAIN_GROUPS_REQUEST,
    };
}

function fetchDomainGroupsSuccess( { domainGroupsById, allDomainGroupIds } ){
    return {
        allDomainGroupIds,
        domainGroupsById,
        type: FETCH_DOMAIN_GROUPS_SUCCESS,
    };
}

function fetchDomainGroupsFailure( error ){
    return {
        error,
        type: FETCH_DOMAIN_GROUPS_FAILURE,
    };
}

export function fetchDomainGroups(){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchDomainGroupsRequest() );
        const api = new MimirService( DATA_API, domainGroupSanitizer );

        return api.getDomainGroups().then(
            ( response ) => dispatch( fetchDomainGroupsSuccess( response ) ),
            ( error ) => dispatch( fetchDomainGroupsFailure( error ) )
        );
    };
}

function deleteDomainGroupRequest(){
    return {
        type: DELETE_DOMAIN_GROUP_REQUEST,
    };
}
function saveDomainGroupRequest(){
    return {
        type: SAVE_DOMAIN_GROUP_REQUEST
    };
}

function saveDomainGroupSuccess( normalizedResponse ){
    return {
        ...normalizedResponse,
        type: SAVE_DOMAIN_GROUP_SUCCESS,
    };
}

function saveDomainGroupFailure( error ){
    return {
        error,
        type: SAVE_DOMAIN_GROUP_FAILURE
    };
}

export function saveDomainGroup( group ){
    return ( dispatch, getState, { DATA_API } ) => {
        const api = new MimirService( DATA_API, domainGroupSanitizer );
        const isPreexistingGroup = Boolean( group.id );

        dispatch( saveDomainGroupRequest() );

        let saveDomainGroup;
        let snackbarAction;

        if( isPreexistingGroup ){
            saveDomainGroup = api.updateDomainGroup( group );
            snackbarAction = openDomainGroupingEditSuccessSnackbar;
        }
        else{
            saveDomainGroup = api.createDomainGroup( group );
            snackbarAction = openDomainGroupingCreateSuccessSnackbar;
        }
        return saveDomainGroup.then(
            ( response ) => {
                dispatch( saveDomainGroupSuccess( response ) );
                dispatch( refreshClaimedDomains() );
                dispatch( snackbarAction( group ) );
            },
            ( error ) => {
                dispatch( saveDomainGroupFailure( error ) );
                dispatch( openDomainGroupingSaveErrorSnackbar() );
            }
        );
    };
}

export function saveDomainGroupFromModal(){
    return ( dispatch, getState ) => {
        const { name, id, description, domains } = domainGroupFormStateSelector( getState() );
        const unSavedGroup = {
            description,
            domains,
            id,
            name,
        };
        return dispatch( saveDomainGroup( unSavedGroup ) );
    };
}

function deleteDomainGroupSuccess( groupId ){
    return {
        id: groupId,
        type: DELETE_DOMAIN_GROUP_SUCCESS,
    };
}

function deleteDomainGroupError( error ){
    return {
        error,
        type: DELETE_DOMAIN_GROUP_ERROR,
    };
}

export function deleteDomainGroup( groupId, groupName ){
    return ( dispatch, getState, { DATA_API } ) => {

        dispatch( deleteDomainGroupRequest( ) );
        const api = new MimirService( DATA_API );

        return api.deleteDomainGroup( groupId ).then(
            ( response ) => {
                dispatch( deleteDomainGroupSuccess( groupId ) );
                dispatch( refreshClaimedDomains() );
                dispatch( openDomainGroupingDeleteSuccessSnackbar( groupName ) );
            },
            ( error ) => {
                dispatch( openDomainGroupingDeleteErrorSnackbar( ) );
                dispatch( deleteDomainGroupError( error ) );
            }
        );
    };
}

function deleteGroupsFromDomainsRequest(){
    return {
        type: DELETE_GROUPS_FROM_DOMAINS_REQUEST
    };
}

function deleteGroupsFromDomainsSuccess( ){
    return {
        type: DELETE_GROUPS_FROM_DOMAINS_SUCCESS,
    };
}

function deleteGroupsFromDomainsFailure( error ){
    return {
        error,
        type: DELETE_GROUPS_FROM_DOMAINS_FAILURE
    };
}

export function deleteGroupsFromDomains( domains ){
    return ( dispatch, getState, { DATA_API } ) => {

        dispatch( deleteGroupsFromDomainsRequest( ) );
        const api = new MimirService( DATA_API );
        const allRequests = [];

        domains.map( domain => allRequests.push( api.deleteGroupsFromDomains( domain ) ) );

        return Promise.all( allRequests ).then( ( responses ) => {
            dispatch( deleteGroupsFromDomainsSuccess( ) );
            dispatch( refreshClaimedDomains() );
            dispatch( fetchDomainGroups() );
            if(  some( responses,[ 'status', 207] ) ){
                dispatch( openRemoveDomainsFromGroupsErrorSnackbar( ) );
            }
            else{
                dispatch( openRemoveDomainsFromGroupsSuccessSnackbar( ) );
            }
        } ).catch( ( error ) => {
            dispatch( refreshClaimedDomains() );
            dispatch( fetchDomainGroups() );
            dispatch( deleteGroupsFromDomainsFailure( error ) );
            dispatch( openRemoveDomainsFromGroupsErrorSnackbar( ) );
        } );
    };
}

// *** Domain Grouping Form Action Creators ***
// These action creators manipulate and maintain the 
// "dirty" domain grouping form state
export function createDomainGroup( name ){
    return {
        name,
        type: CREATE_DOMAIN_GROUP,
    };
}

export function selectDomainGroup( id ){
    return ( dispatch, getState ) => {
        let selectedGroup;
        let preSelectedDomains = [];
        const isAssignMode = isAssigningDomainsToGroupSelector( getState() );

        if( Boolean( id ) ){
            selectedGroup = domainGroupsByIdSelector( getState() )[id];
        }
        else{
            selectedGroup = {
                description: '',
                domains: [],
                name: '',
            };
        }

        if( isAssignMode ){
            // TODO: make unique
            preSelectedDomains = [...modalPreselectedDomainsForAGroupSelector( getState() )];
        }
        return dispatch( {
            ...selectedGroup,
            domains: uniq( [...selectedGroup.domains, ...preSelectedDomains] ),
            type: SELECT_DOMAIN_GROUP,
        } );
    };
}

export function renameSelectedDomainGroup( name ){
    return {
        name,
        type: RENAME_SELECTED_DOMAIN_GROUP,
    };
}

export function updateDomainsInSelectedGroup( domains ){
    return {
        domains,
        type: UPDATE_DOMAINS_IN_SELECTED_GROUP,
    };
}

export function dismissDomainGroupingForm(){
    return {
        type: DISMISS_DOMAIN_GROUPING_FORM,
    };
}

